import { DialogActions, DialogContent } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";

export const GeneralDialog = (props)=>{
    const {children, ...withoutChildren} = props
    return(
        <Dialog {...withoutChildren}>
            {children}
        </Dialog>
    )
}
export const GeneralDialogTitle = (props) =>{
    return(
        <DialogTitle>
            {props.children}
        </DialogTitle>
    )
}
export const GeneralDialogContent = props =>{
    const {children, ...withoutChildren} = props
    return(
        <DialogContent {...withoutChildren}>
            {children}
        </DialogContent>
    )
}
export const GeneralDialogActions = props =>{
    return(
        <DialogActions>
            {props.children}
        </DialogActions>
    )
}